module.exports = (__webpack_require__(5))(79);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/ItemListWidget.js from dll-reference girder_plugin_large_image_annotation
// module id = 169
// module chunks = 0